/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Reason_ExpiredInputs */

const vi_warehouse_defects_reason_expired = /** @type {(inputs: Warehouse_Defects_Reason_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hết hạn`)
};

/**

* @param {Warehouse_Defects_Reason_ExpiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_reason_expired = /** @type {((inputs?: Warehouse_Defects_Reason_ExpiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Reason_ExpiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_reason_expired(inputs)
});